export const RESTORE_POLICY_FIXED_SECTIONS = {
  FINANCIAL_PLAN_2_5: `【財務状況の把握】
・資金繰りを定期的に確認し、緊急時に利用可能な資金を確保する。

【資金調達先】
・地元金融機関、取引銀行、政府系金融機関（日本政策金融公庫など）との連携を強化し、緊急時に迅速な資金調達ができる体制を整備する。

【相談先】
・地元商工会議所、金融機関担当者、専門コンサルタントを活用し、資金計画を定期的に見直す。`,
} as const;
